import {
    GET_SUPER_SERVICEABLE_AREA,
    GET_ALL_SUPER_SERVICEABLE_AREAS,
    GET_SUPER_SERVICEABLE_AREA_REQUEST,
    CREATE_SUPER_SERVICEABLE_AREA,
    UPDATE_SUPER_SERVICEABLE_AREA,
    DELETE_SUPER_SERVICEABLE_AREA,
    CLEAR_SUPER_SERVICEABLE_AREA,
    SUPER_SERVICEABLE_AREA_ERROR,
    SUPER_SERVICEABLE_AREA_LOADING
} from '../actions/types';

const initialState = {
    superServiceableAreas: [],
    superServiceableArea: null,
    loading: false,
    error: null
};

export default function superServiceableAreaReducer(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case SUPER_SERVICEABLE_AREA_LOADING:
            return {
                ...state,
                loading: true,
                error: null
            };

        case GET_ALL_SUPER_SERVICEABLE_AREAS:
            return {
                ...state,
                superServiceableAreas: payload,
                loading: false,
                error: null
            };

        case GET_SUPER_SERVICEABLE_AREA_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };

        case GET_SUPER_SERVICEABLE_AREA:
            return {
                ...state,
                superServiceableArea: payload,
                loading: false,
                error: null
            };

        case CREATE_SUPER_SERVICEABLE_AREA:
            return {
                ...state,
                superServiceableAreas: [...state.superServiceableAreas, payload],
                loading: false,
                error: null
            };

        case UPDATE_SUPER_SERVICEABLE_AREA:
            return {
                ...state,
                superServiceableAreas: state.superServiceableAreas.map(area =>
                    area._id === payload._id ? payload : area
                ),
                superServiceableArea: payload,
                loading: false,
                error: null
            };

        case DELETE_SUPER_SERVICEABLE_AREA:
            return {
                ...state,
                superServiceableAreas: state.superServiceableAreas.filter(area => area._id !== payload),
                loading: false,
                error: null
            };

        case CLEAR_SUPER_SERVICEABLE_AREA:
            return {
                ...state,
                superServiceableArea: null,
                error: null
            };

        case SUPER_SERVICEABLE_AREA_ERROR:
            return {
                ...state,
                error: payload,
                loading: false
            };

        default:
            return state;
    }
}
